module.exports = __webpack_public_path__ + "static/media/8.fe8d82fb.jpg";